var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPipelineIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1672,
    stopColor: "#ffdd73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3563,
    stopColor: "#ffd065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5559,
    stopColor: "#ffbc4e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7629,
    stopColor: "#fea02f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9738,
    stopColor: "#fe7c06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe7701"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 350.939,
    x2: 421.586,
    xlinkHref: "#lg1",
    y1: 28.821,
    y2: 99.467
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000018935673482721909130000012288552327042767536_",
    gradientUnits: "userSpaceOnUse",
    x1: 77.86,
    x2: 148.507,
    xlinkHref: "#lg1",
    y1: 399.979,
    y2: 470.626
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#feaee1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1363,
    stopColor: "#fda9dd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2904,
    stopColor: "#fb9bd2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4533,
    stopColor: "#f785c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6222,
    stopColor: "#f265a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7958,
    stopColor: "#ec3c85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.971,
    stopColor: "#e40b5d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e30256"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000024713480335863859490000009104040412464315299_",
    gradientUnits: "userSpaceOnUse",
    x1: 271.992,
    x2: 511.43,
    xlinkHref: "#lg2",
    y1: 218.918,
    y2: 458.357
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5b3374",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5b3374"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000151507854479013178390000010600579511952656279_",
    gradientTransform: "matrix(0 1 1 0 -371.878 371.878)",
    gradientUnits: "userSpaceOnUse",
    x1: -33.412,
    x2: -33.412,
    xlinkHref: "#lg3",
    y1: 805.609,
    y2: 878.716
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000112596328467516820520000012675835141377009080_",
    gradientUnits: "userSpaceOnUse",
    x1: 391.539,
    x2: 391.539,
    xlinkHref: "#lg3",
    y1: 454.656,
    y2: 513.183
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000091711999841769200340000001509428541677691528_",
    gradientUnits: "userSpaceOnUse",
    x1: 391.539,
    x2: 391.539,
    xlinkHref: "#lg3",
    y1: 395.691,
    y2: 334.852
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000076566204779593530700000002034501900256158123_",
    gradientTransform: "matrix(0 1 1 0 -1149.232 1149.232)",
    gradientUnits: "userSpaceOnUse",
    x1: -1040.094,
    x2: -747.952,
    y1: 1258.37,
    y2: 1550.512
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d9b1ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#814aa0"
  }))), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000173155244848949123490000015831046875345701793_",
    gradientUnits: "userSpaceOnUse",
    x1: 299.074,
    x2: 173.583,
    xlinkHref: "#lg3",
    y1: 255,
    y2: 255
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000069383045323281560830000007470934773060511661_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg3",
    y1: 291.296,
    y2: 351.587
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008143572832951464700000016252999791991806394_",
    gradientTransform: "matrix(0 1 1 0 -1149.232 1149.232)",
    gradientUnits: "userSpaceOnUse",
    x1: -894.232,
    x2: -894.232,
    xlinkHref: "#lg3",
    y1: 1573.496,
    y2: 1632.023
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000089566990813743445780000010047136945887667866_",
    gradientUnits: "userSpaceOnUse",
    x1: -1.087,
    x2: 238.351,
    xlinkHref: "#lg2",
    y1: 51.987,
    y2: 291.425
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000091000262277721820710000004601038367409823924_",
    gradientTransform: "matrix(0 1 1 0 -371.878 371.878)",
    gradientUnits: "userSpaceOnUse",
    x1: -200.344,
    x2: -200.344,
    xlinkHref: "#lg3",
    y1: 532.53,
    y2: 605.637
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000140725962441002627130000005085634681799679928_",
    gradientUnits: "userSpaceOnUse",
    x1: 118.46,
    x2: 118.46,
    xlinkHref: "#lg3",
    y1: 287.725,
    y2: 346.252
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000178189771202763025980000018355060062028221064_",
    gradientUnits: "userSpaceOnUse",
    x1: 353.519,
    x2: 440.63,
    xlinkHref: "#lg3",
    y1: 146.157,
    y2: 426.156
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000078031049418253617440000002669953872556259733_",
    gradientUnits: "userSpaceOnUse",
    x1: 30.027,
    x2: 219.795,
    xlinkHref: "#lg3",
    y1: 97.943,
    y2: 410.593
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 391.539,
    cy: 69.421,
    fill: "url(#SVGID_1_)",
    r: 69.421
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 118.461,
    cy: 440.579,
    fill: "url(#SVGID_00000018935673482721909130000012288552327042767536_)",
    r: 69.421
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m448.054 510h-113.03c-17.427 0-31.554-14.127-31.554-31.554v-279.961c0-17.427 14.127-31.554 31.554-31.554h113.03c17.427 0 31.554 14.127 31.554 31.554v279.961c0 17.427-14.127 31.554-31.554 31.554z",
    fill: "url(#SVGID_00000024713480335863859490000009104040412464315299_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m369.957 166.932h78.098c17.427 0 31.554 14.127 31.554 31.554v279.961c0 17.427-14.127 31.554-31.554 31.554h-78.098z",
    fill: "url(#SVGID_00000151507854479013178390000010600579511952656279_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m303.471 324.077v154.369c0 17.427 14.127 31.554 31.554 31.554h113.03c17.427 0 31.554-14.127 31.554-31.554v-154.369z",
    fill: "url(#SVGID_00000112596328467516820520000012675835141377009080_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m303.471 314.398h176.137v114.477h-176.137z",
    fill: "url(#SVGID_00000091711999841769200340000001509428541677691528_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m479.608 311.515v-113.03c0-17.427-14.127-31.554-31.554-31.554h-386.108c-17.427 0-31.554 14.127-31.554 31.554v113.03c0 17.427 14.127 31.554 31.554 31.554h386.109c17.426-.001 31.553-14.128 31.553-31.554z",
    fill: "url(#SVGID_00000076566204779593530700000002034501900256158123_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.392 198.485v113.03c0 17.427 14.127 31.554 31.554 31.554h320.72l-176.137-176.137h-144.583c-17.427 0-31.554 14.127-31.554 31.553z",
    fill: "url(#SVGID_00000173155244848949123490000015831046875345701793_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.392 233.417v78.098c0 17.427 14.127 31.554 31.554 31.554h386.109c17.427 0 31.554-14.127 31.554-31.554v-78.098z",
    fill: "url(#SVGID_00000069383045323281560830000007470934773060511661_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m293.685 166.932h154.369c17.427 0 31.554 14.127 31.554 31.554v113.03c0 17.427-14.127 31.554-31.554 31.554h-154.369z",
    fill: "url(#SVGID_00000008143572832951464700000016252999791991806394_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m174.975 343.068h-113.029c-17.427 0-31.554-14.127-31.554-31.554v-279.96c0-17.427 14.127-31.554 31.554-31.554h113.03c17.427 0 31.554 14.127 31.554 31.554v279.961c-.001 17.426-14.128 31.553-31.555 31.553z",
    fill: "url(#SVGID_00000089566990813743445780000010047136945887667866_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96.878 0h78.098c17.427 0 31.554 14.127 31.554 31.554v279.961c0 17.427-14.127 31.554-31.554 31.554h-78.098z",
    fill: "url(#SVGID_00000091000262277721820710000004601038367409823924_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.392 157.146v154.369c0 17.427 14.127 31.554 31.554 31.554h113.03c17.427 0 31.554-14.127 31.554-31.554v-154.369z",
    fill: "url(#SVGID_00000140725962441002627130000005085634681799679928_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m448.054 166.932h-113.03c-17.427 0-31.554 14.127-31.554 31.554v144.583h144.583c17.427 0 31.554-14.127 31.554-31.554v-113.03c.001-17.426-14.126-31.553-31.553-31.553z",
    fill: "url(#SVGID_00000178189771202763025980000018355060062028221064_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m206.529 311.515v-144.583h-144.583c-17.426 0-31.552 14.126-31.554 31.551v113.035c.001 17.425 14.128 31.551 31.554 31.551h113.03c17.426-.001 31.553-14.128 31.553-31.554z",
    fill: "url(#SVGID_00000078031049418253617440000002669953872556259733_)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPipelineIcon);
export default __webpack_public_path__ + "static/media/pipeline-icon.c7d040ce12083fbc8a4dd741cf3c9b2d.svg";
export { ForwardRef as ReactComponent };